"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELEMENT_ROLES_BY_TYPE = exports.ELEMENT_ROLE_GROUPS = exports.ElementRoleGroup = exports.ELEMENT_ROLE_LABELS = exports.ElementRole = void 0;
var ElementRole;
(function (ElementRole) {
    ElementRole["heading"] = "heading";
    ElementRole["subheading"] = "subheading";
    ElementRole["title"] = "title";
    ElementRole["subtitle"] = "subtitle";
    ElementRole["headingDescription"] = "headingDescription";
    ElementRole["headingContent"] = "headingContent";
    ElementRole["text"] = "text";
    ElementRole["paragraph"] = "paragraph";
    ElementRole["description"] = "description";
    ElementRole["caption"] = "caption";
    ElementRole["label"] = "label";
    ElementRole["note"] = "note";
    ElementRole["quote"] = "quote";
    ElementRole["copyright"] = "copyright";
    ElementRole["date"] = "date";
    ElementRole["number"] = "number";
    ElementRole["badge"] = "badge";
    ElementRole["item"] = "item";
    ElementRole["author"] = "author";
    ElementRole["authors"] = "authors";
    ElementRole["authorName"] = "authorName";
    ElementRole["authorPhoto"] = "authorPhoto";
    ElementRole["authorBio"] = "authorBio";
    ElementRole["image"] = "image";
    ElementRole["photo"] = "photo";
    ElementRole["icon"] = "icon";
    ElementRole["logo"] = "logo";
    ElementRole["background"] = "background";
    ElementRole["thumbnail"] = "thumbnail";
    ElementRole["avatar"] = "avatar";
    ElementRole["illustration"] = "illustration";
    ElementRole["audio"] = "audio";
    ElementRole["video"] = "video";
    ElementRole["code"] = "code";
    ElementRole["embed"] = "embed";
    ElementRole["file"] = "file";
    ElementRole["checkbox"] = "checkbox";
    ElementRole["button"] = "button";
    ElementRole["link"] = "link";
    ElementRole["list"] = "list";
    ElementRole["table"] = "table";
    ElementRole["chart"] = "chart";
    ElementRole["labeledGraphic"] = "labeledGraphic";
    ElementRole["card"] = "card";
    ElementRole["divider"] = "divider";
    ElementRole["separator"] = "separator";
    ElementRole["spacer"] = "spacer";
    ElementRole["question"] = "question";
    ElementRole["answer"] = "answer";
    ElementRole["answerOption"] = "answerOption";
    ElementRole["answerFeedback"] = "answerFeedback";
    ElementRole["distribution"] = "distribution";
    ElementRole["testStartInfo"] = "testStartInfo";
    ElementRole["testRetry"] = "testRetry";
    ElementRole["testFinish"] = "testFinish";
    ElementRole["testEndInfo"] = "testEndInfo";
    ElementRole["testResultChart"] = "testResultChart";
    ElementRole["buttons"] = "buttons";
    ElementRole["cards"] = "cards";
    ElementRole["tabs"] = "tabs";
    ElementRole["accordion"] = "accordion";
    ElementRole["process"] = "process";
    ElementRole["timeline"] = "timeline";
    ElementRole["gallery"] = "gallery";
    ElementRole["carousel"] = "carousel";
    ElementRole["quotes"] = "quotes";
    ElementRole["grid"] = "grid";
    ElementRole["stack"] = "stack";
    ElementRole["header"] = "header";
    ElementRole["footer"] = "footer";
    ElementRole["sidebar"] = "sidebar";
    ElementRole["container"] = "container";
    ElementRole["wrapper"] = "wrapper";
})(ElementRole || (exports.ElementRole = ElementRole = {}));
exports.ELEMENT_ROLE_LABELS = {
    [ElementRole.heading]: 'Heading',
    [ElementRole.subheading]: 'Subheading',
    [ElementRole.title]: 'Title',
    [ElementRole.subtitle]: 'Subtitle',
    [ElementRole.headingDescription]: 'Heading Description',
    [ElementRole.headingContent]: 'Heading Content',
    [ElementRole.text]: 'Text',
    [ElementRole.paragraph]: 'Paragraph',
    [ElementRole.description]: 'Description',
    [ElementRole.caption]: 'Caption',
    [ElementRole.label]: 'Label',
    [ElementRole.note]: 'Note',
    [ElementRole.quote]: 'Quote',
    [ElementRole.copyright]: 'Copyright',
    [ElementRole.date]: 'Date',
    [ElementRole.number]: 'Number',
    [ElementRole.badge]: 'Badge',
    [ElementRole.item]: 'Item',
    [ElementRole.author]: 'Author',
    [ElementRole.authors]: 'Authors',
    [ElementRole.authorName]: 'Author Name',
    [ElementRole.authorPhoto]: 'Author Photo',
    [ElementRole.authorBio]: 'Author Bio',
    [ElementRole.image]: 'Image',
    [ElementRole.photo]: 'Photo',
    [ElementRole.icon]: 'Icon',
    [ElementRole.logo]: 'Logo',
    [ElementRole.background]: 'Background',
    [ElementRole.thumbnail]: 'Thumbnail',
    [ElementRole.avatar]: 'Avatar',
    [ElementRole.illustration]: 'Illustration',
    [ElementRole.audio]: 'Audio',
    [ElementRole.video]: 'Video',
    [ElementRole.code]: 'Code',
    [ElementRole.embed]: 'Embed',
    [ElementRole.file]: 'File / Download',
    [ElementRole.checkbox]: 'Checkbox',
    [ElementRole.button]: 'Button',
    [ElementRole.link]: 'Link',
    [ElementRole.list]: 'List',
    [ElementRole.table]: 'Table',
    [ElementRole.chart]: 'Chart',
    [ElementRole.labeledGraphic]: 'Labeled Graphic',
    [ElementRole.card]: 'Card',
    [ElementRole.divider]: 'Divider',
    [ElementRole.separator]: 'Separator',
    [ElementRole.spacer]: 'Spacer',
    [ElementRole.question]: 'Question',
    [ElementRole.answer]: 'Answer',
    [ElementRole.answerOption]: 'Answer Option',
    [ElementRole.answerFeedback]: 'Answer Feedback',
    [ElementRole.distribution]: 'Distribution',
    [ElementRole.testStartInfo]: 'Test Start Info',
    [ElementRole.testRetry]: 'Test Retry',
    [ElementRole.testFinish]: 'Test Finish',
    [ElementRole.testEndInfo]: 'Test End Info',
    [ElementRole.testResultChart]: 'Test Result Chart',
    [ElementRole.buttons]: 'Buttons Group',
    [ElementRole.cards]: 'Cards Group',
    [ElementRole.tabs]: 'Tabs',
    [ElementRole.accordion]: 'Accordion',
    [ElementRole.process]: 'Process',
    [ElementRole.timeline]: 'Timeline',
    [ElementRole.gallery]: 'Gallery',
    [ElementRole.carousel]: 'Carousel',
    [ElementRole.quotes]: 'Quotes',
    [ElementRole.grid]: 'Grid',
    [ElementRole.stack]: 'Stack',
    [ElementRole.header]: 'Header',
    [ElementRole.footer]: 'Footer',
    [ElementRole.sidebar]: 'Sidebar',
    [ElementRole.container]: 'Container',
    [ElementRole.wrapper]: 'Wrapper',
};
var ElementRoleGroup;
(function (ElementRoleGroup) {
    ElementRoleGroup["content"] = "content";
    ElementRoleGroup["people"] = "people";
    ElementRoleGroup["media"] = "media";
    ElementRoleGroup["interactive"] = "interactive";
    ElementRoleGroup["test"] = "test";
    ElementRoleGroup["complex"] = "complex";
    ElementRoleGroup["layout"] = "layout";
})(ElementRoleGroup || (exports.ElementRoleGroup = ElementRoleGroup = {}));
exports.ELEMENT_ROLE_GROUPS = {
    [ElementRoleGroup.content]: [
        ElementRole.heading,
        ElementRole.subheading,
        ElementRole.title,
        ElementRole.subtitle,
        ElementRole.headingDescription,
        ElementRole.headingContent,
        ElementRole.text,
        ElementRole.paragraph,
        ElementRole.description,
        ElementRole.caption,
        ElementRole.label,
        ElementRole.note,
        ElementRole.quote,
        ElementRole.copyright,
        ElementRole.date,
        ElementRole.number,
        ElementRole.badge,
        ElementRole.item,
    ],
    [ElementRoleGroup.people]: [
        ElementRole.author,
        ElementRole.authors,
        ElementRole.authorName,
        ElementRole.authorPhoto,
        ElementRole.authorBio,
    ],
    [ElementRoleGroup.media]: [
        ElementRole.image,
        ElementRole.photo,
        ElementRole.icon,
        ElementRole.logo,
        ElementRole.background,
        ElementRole.thumbnail,
        ElementRole.avatar,
        ElementRole.illustration,
        ElementRole.audio,
        ElementRole.video,
        ElementRole.code,
        ElementRole.embed,
        ElementRole.file,
    ],
    [ElementRoleGroup.interactive]: [
        ElementRole.checkbox,
        ElementRole.button,
        ElementRole.link,
        ElementRole.list,
        ElementRole.table,
        ElementRole.chart,
        ElementRole.labeledGraphic,
        ElementRole.card,
        ElementRole.divider,
        ElementRole.separator,
        ElementRole.spacer,
    ],
    [ElementRoleGroup.test]: [
        ElementRole.question,
        ElementRole.answer,
        ElementRole.answerOption,
        ElementRole.answerFeedback,
        ElementRole.distribution,
        ElementRole.testStartInfo,
        ElementRole.testRetry,
        ElementRole.testFinish,
        ElementRole.testEndInfo,
        ElementRole.testResultChart,
    ],
    [ElementRoleGroup.complex]: [
        ElementRole.buttons,
        ElementRole.cards,
        ElementRole.tabs,
        ElementRole.accordion,
        ElementRole.process,
        ElementRole.timeline,
        ElementRole.gallery,
        ElementRole.carousel,
        ElementRole.quotes,
        ElementRole.grid,
        ElementRole.stack,
    ],
    [ElementRoleGroup.layout]: [
        ElementRole.header,
        ElementRole.footer,
        ElementRole.sidebar,
        ElementRole.container,
        ElementRole.wrapper,
    ],
};
exports.ELEMENT_ROLES_BY_TYPE = {
    richText: [
        ElementRole.heading,
        ElementRole.subheading,
        ElementRole.title,
        ElementRole.subtitle,
        ElementRole.headingDescription,
        ElementRole.headingContent,
        ElementRole.text,
        ElementRole.paragraph,
        ElementRole.description,
        ElementRole.caption,
        ElementRole.label,
        ElementRole.note,
        ElementRole.quote,
        ElementRole.copyright,
        ElementRole.date,
        ElementRole.number,
        ElementRole.badge,
        ElementRole.author,
        ElementRole.authorName,
        ElementRole.authorBio,
        ElementRole.question,
        ElementRole.answer,
        ElementRole.item,
        ElementRole.testStartInfo,
        ElementRole.testEndInfo,
    ],
    image: [
        ElementRole.image,
        ElementRole.photo,
        ElementRole.icon,
        ElementRole.logo,
        ElementRole.background,
        ElementRole.thumbnail,
        ElementRole.avatar,
        ElementRole.illustration,
        ElementRole.authorPhoto,
        ElementRole.caption,
    ],
    audio: [ElementRole.audio],
    video: [ElementRole.video],
    button: [ElementRole.button, ElementRole.link, ElementRole.testFinish, ElementRole.testRetry],
    checkbox: [ElementRole.checkbox],
    list: [ElementRole.list],
    table: [ElementRole.table],
    chart: [ElementRole.chart],
    labeledGraphic: [ElementRole.labeledGraphic],
    card: [ElementRole.card],
    code: [ElementRole.code],
    embedded: [ElementRole.embed],
    downloader: [ElementRole.file],
    link: [ElementRole.link, ElementRole.button],
    tabs: [ElementRole.tabs],
    accordion: [ElementRole.accordion],
    slider: [
        ElementRole.gallery,
        ElementRole.carousel,
        ElementRole.quotes,
        ElementRole.cards,
        ElementRole.process,
    ],
    layoutList: [ElementRole.buttons, ElementRole.timeline],
    grouping: [ElementRole.distribution],
    divider: [ElementRole.divider, ElementRole.separator, ElementRole.spacer, ElementRole.item],
    rectangle: [ElementRole.background, ElementRole.container],
    reflection: [ElementRole.question, ElementRole.answer],
    testSingleChoice: [ElementRole.question, ElementRole.answer],
    testMultipleChoice: [ElementRole.question, ElementRole.answer],
    testKeyboardInput: [ElementRole.question, ElementRole.answer],
    testMatching: [ElementRole.question, ElementRole.answer],
    testRanking: [ElementRole.question],
    testHotspot: [ElementRole.question],
    testGrouping: [ElementRole.question],
    testResult: [ElementRole.testResultChart],
    testInfoStart: [ElementRole.testStartInfo],
    testInfoEnd: [ElementRole.testEndInfo],
    testFeedback: [ElementRole.answerFeedback, ElementRole.answer],
};
